import React from 'react';

export const ArobaseIcon = (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M12,1.95 C6.48,1.95 2,6.43 2,11.95 C2,17.47 6.48,21.95 12,21.95 L17,21.95 L17,19.95 L12,19.95 C7.66,19.95 4,16.29 4,11.95 C4,7.61 7.66,3.95 12,3.95 C16.34,3.95 20,7.61 20,11.95 L20,13.38 C20,14.17 19.29,14.95 18.5,14.95 C17.71,14.95 17,14.17 17,13.38 L17,11.95 C17,9.19 14.76,6.95 12,6.95 C9.24,6.95 7,9.19 7,11.95 C7,14.71 9.24,16.95 12,16.95 C13.38,16.95 14.64,16.39 15.54,15.48 C16.19,16.37 17.31,16.95 18.5,16.95 C20.47,16.95 22,15.35 22,13.38 L22,11.95 C22,6.43 17.52,1.95 12,1.95 Z M12,14.95 C10.34,14.95 9,13.61 9,11.95 C9,10.29 10.34,8.95 12,8.95 C13.66,8.95 15,10.29 15,11.95 C15,13.61 13.66,14.95 12,14.95 Z"
      fillRule="nonzero"
    />
  </svg>
);

export const DocIcon = (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M8,16 L16,16 L16,18 L8,18 L8,16 Z M8,12 L16,12 L16,14 L8,14 L8,12 Z M14,2 L6,2 C4.9,2 4,2.9 4,4 L4,20 C4,21.1 4.89,22 5.99,22 L18,22 C19.1,22 20,21.1 20,20 L20,8 L14,2 Z M18,20 L6,20 L6,4 L13,4 L13,9 L18,9 L18,20 Z"
      fillRule="nonzero"
    />
  </svg>
);

export const DownloadIcon = (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M15.75,11.75 L11.99925,15.5007 L8.24925,11.75 M12,15.5 L12,5 L12,15.5 Z M18,18.5 L6,18.5 L18,18.5 Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const EmailIcon = (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M15.3746,12.718 L19.8806,9.663 C20.5816,9.189 21.0006,8.398 21.0006,7.552 C21.0006,6.142 19.8586,5 18.4496,5 L5.56662,5 C4.15762,5 3.01562,6.142 3.01562,7.551 C3.01562,8.397 3.43463,9.188 4.13563,9.663 L8.64162,12.718 C10.6746,14.096 13.3416,14.096 15.3746,12.718 L15.3746,12.718 Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3,7.55099 L3,17 C3,18.657 4.343,20 6,20 L18,20 C19.657,20 21,18.657 21,17 L21,7.55199"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const EventIcon = (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M17,12 L12,12 L12,17 L17,17 L17,12 Z M16,1 L16,3 L8,3 L8,1 L6,1 L6,3 L5,3 C3.89,3 3.01,3.9 3.01,5 L3,19 C3,20.1 3.89,21 5,21 L19,21 C20.1,21 21,20.1 21,19 L21,5 C21,3.9 20.1,3 19,3 L18,3 L18,1 L16,1 Z M19,19 L5,19 L5,8 L19,8 L19,19 Z"
      fillRule="nonzero"
    />
  </svg>
);

export const ExpandMoreIcon = (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <polygon fillRule="nonzero" points="16.59 8.59 12 13.17 7.41 8.59 6 10 12 16 18 10" />
  </svg>
);

export const FaxIcon = (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M5.57142857,4.92857143 C5.57142857,3.86344714 6.43487571,3 7.5,3 L16.5,3 C17.5650857,3 18.4285714,3.86344714 18.4285714,4.92857143 L18.4285714,8.14285714 L17.1428571,8.14285714 L17.1428571,4.92857143 C17.1428571,4.57353429 16.8549857,4.28571429 16.5,4.28571429 L7.5,4.28571429 C7.14496286,4.28571429 6.85714286,4.57353429 6.85714286,4.92857143 L6.85714286,9.42857143 L13.9283143,9.42857143 C13.6476429,9.80232857 13.4464286,10.2392914 13.35,10.7142857 L5.57142857,10.7142857 C4.86135429,10.7142857 4.28571429,11.2899129 4.28571429,12 L4.28571429,19.0714286 C4.28571429,19.4264143 4.57353429,19.7142857 4.92857143,19.7142857 L13.35,19.7142857 C13.4464286,20.1892286 13.6476429,20.6262429 13.9283143,21 L4.92857143,21 C3.86344714,21 3,20.1365143 3,19.0714286 L3,12 C3,10.5798386 4.15126714,9.42857143 5.57142857,9.42857143 L5.57142857,4.92857143 Z M14.5714286,11.3571429 C14.5714286,10.2920186 15.4349143,9.42857143 16.5,9.42857143 L19.0714286,9.42857143 C20.1365143,9.42857143 21,10.2920186 21,11.3571429 L21,19.0714286 C21,20.1365143 20.1365143,21 19.0714286,21 L16.5,21 C15.4349143,21 14.5714286,20.1365143 14.5714286,19.0714286 L14.5714286,11.3571429 Z M16.5,10.7142857 C16.1450143,10.7142857 15.8571429,11.0021057 15.8571429,11.3571429 L15.8571429,19.0714286 C15.8571429,19.4264143 16.1450143,19.7142857 16.5,19.7142857 L19.0714286,19.7142857 C19.4264143,19.7142857 19.7142857,19.4264143 19.7142857,19.0714286 L19.7142857,11.3571429 C19.7142857,11.0021057 19.4264143,10.7142857 19.0714286,10.7142857 L16.5,10.7142857 Z M6.375,12 C6.81880286,12 7.17857143,12.3597429 7.17857143,12.8035714 C7.17857143,13.2474 6.81880286,13.6071429 6.375,13.6071429 C5.93119714,13.6071429 5.57142857,13.2474 5.57142857,12.8035714 C5.57142857,12.3597429 5.93119714,12 6.375,12 Z M6.375,14.8928571 C6.81880286,14.8928571 7.17857143,15.2526 7.17857143,15.6964286 C7.17857143,16.1402571 6.81880286,16.5 6.375,16.5 C5.93119714,16.5 5.57142857,16.1402571 5.57142857,15.6964286 C5.57142857,15.2526 5.93119714,14.8928571 6.375,14.8928571 Z M10.0714286,15.8571429 C10.0714286,15.4133143 9.71166,15.0535714 9.26785714,15.0535714 C8.82405429,15.0535714 8.46428571,15.4133143 8.46428571,15.8571429 C8.46428571,16.3009714 8.82405429,16.6607143 9.26785714,16.6607143 C9.71166,16.6607143 10.0714286,16.3009714 10.0714286,15.8571429 Z M9.26785714,12 C9.71166,12 10.0714286,12.3597429 10.0714286,12.8035714 C10.0714286,13.2474 9.71166,13.6071429 9.26785714,13.6071429 C8.82405429,13.6071429 8.46428571,13.2474 8.46428571,12.8035714 C8.46428571,12.3597429 8.82405429,12 9.26785714,12 Z"
      fillRule="nonzero"
    ></path>
  </svg>
);

export const MarketIcon = (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M20,6 L12,6 L10,4 L4,4 C2.9,4 2.01,4.9 2.01,6 L2,18 C2,19.1 2.9,20 4,20 L20,20 C21.1,20 22,19.1 22,18 L22,8 C22,6.9 21.1,6 20,6 Z M20,18 L4,18 L4,6 L9.17,6 L11.17,8 L20,8 L20,18 Z M18,12 L6,12 L6,10 L18,10 L18,12 Z M14,16 L6,16 L6,14 L14,14 L14,16 Z"
      fillRule="nonzero"
    />
  </svg>
);

export const MenuIcon = (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M3,18 L21,18 L21,16 L3,16 L3,18 Z M3,13 L21,13 L21,11 L3,11 L3,13 Z M3,6 L3,8 L21,8 L21,6 L3,6 Z"
      fillRule="nonzero"
    />
  </svg>
);

export const MoreIcon = (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M6,10 C4.9,10 4,10.9 4,12 C4,13.1 4.9,14 6,14 C7.1,14 8,13.1 8,12 C8,10.9 7.1,10 6,10 Z M18,10 C16.9,10 16,10.9 16,12 C16,13.1 16.9,14 18,14 C19.1,14 20,13.1 20,12 C20,10.9 19.1,10 18,10 Z M12,10 C10.9,10 10,10.9 10,12 C10,13.1 10.9,14 12,14 C13.1,14 14,13.1 14,12 C14,10.9 13.1,10 12,10 Z"
      fillRule="nonzero"
    />
  </svg>
);

export const PhoneIcon = (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M11.1314864,13.41976 C9.96153641,12.24976 9.07953641,10.93976 8.49353641,9.61075 C8.36953641,9.32975 8.44253641,9.00075 8.65953641,8.78375 L9.47853641,7.96575 C10.1495364,7.29475 10.1495364,6.34575 9.56353641,5.75975 L8.38953641,4.58575 C7.60853641,3.80475 6.34253641,3.80475 5.56153641,4.58575 L4.90953641,5.23775 C4.16853641,5.97875 3.85953641,7.04775 4.05953641,8.10775 C4.55353641,10.72076 6.07153641,13.58176 8.52053641,16.03076 C10.9694864,18.47976 13.8304864,19.99776 16.4434864,20.49176 C17.5034864,20.69176 18.5724864,20.38276 19.3134864,19.64176 L19.9644864,18.99076 C20.7454864,18.20976 20.7454864,16.94376 19.9644864,16.16276 L18.7914864,14.98976 C18.2054864,14.40376 17.2554864,14.40376 16.6704864,14.98976 L15.7674864,15.89376 C15.5504864,16.11076 15.2214864,16.18376 14.9404864,16.05976 C13.6114864,15.47276 12.3014864,14.58976 11.1314864,13.41976 L11.1314864,13.41976 Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ValidateIcon = (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <polygon points="5 12 10 17 19 8.00002 17.59 6.58002 10 14.17 6.41 10.59" />
  </svg>
);

export const UserIcon = (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M12,2 C6.48,2 2,6.48 2,12 C2,17.52 6.48,22 12,22 C17.52,22 22,17.52 22,12 C22,6.48 17.52,2 12,2 Z M12,5 C13.66,5 15,6.34 15,8 C15,9.66 13.66,11 12,11 C10.34,11 9,9.66 9,8 C9,6.34 10.34,5 12,5 Z M12,19.2 C9.5,19.2 7.29,17.92 6,15.98 C6.03,13.99 10,12.9 12,12.9 C13.99,12.9 17.97,13.99 18,15.98 C16.71,17.92 14.5,19.2 12,19.2 Z"
      fillRule="nonzero"
    />
  </svg>
);

export const BackIcon = (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <polygon fillRule="nonzero" points="15.41 7.41 14 6 8 12 14 18 15.41 16.59 10.83 12" />
  </svg>
);

export const DownloadAllIcon = (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <polyline
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      points="15 10 12 13 9 10"
    />
    <line
      x1="12"
      y1="3"
      x2="12"
      y2="13"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line
      x1="8"
      y1="16"
      x2="16"
      y2="16"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.3643,5.63599 C21.8793,9.15099 21.8793,14.849 18.3643,18.364 C14.8493,21.879 9.15125,21.879 5.63625,18.364 C2.12125,14.849 2.12125,9.15099 5.63625,5.63599"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MenuHomeIcon = (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M3.734,9.764 L12.002,3 L20.267,9.764 C20.731,10.143 21,10.712 21,11.311 L21,19 C21,20.105 20.105,21 19,21 L5,21 C3.895,21 3,20.105 3,19 L3,11.312 C3,10.712 3.269,10.143 3.734,9.764 L3.734,9.764 Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MyMarketIcon = (
  <svg
    version="1.1"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g fill="none">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M13.2678,8.83023c0.976311,0.976311 0.976311,2.55922 0,3.53553c-0.976311,0.976311 -2.55922,0.976311 -3.53553,0c-0.976311,-0.976311 -0.976311,-2.55922 0,-3.53553c0.976311,-0.976311 2.55922,-0.976311 3.53553,0"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M21,13.982v-7.884c0,-1.105 -0.895,-2 -2,-2h-15c-1.105,0 -2,0.895 -2,2v9c0,1.105 0.895,2 2,2h8.261"
      />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M5,14.1h2" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M16,7.1h2" />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M15.374,14.959c-1.871,0.057 -3.374,1.583 -3.374,3.469c0,1.921 1.558,3.479 3.479,3.479c1.397,0 2.593,-0.828 3.146,-2.016"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M18.521,19.902c-1.921,0 -3.479,-1.558 -3.479,-3.479c0,-1.921 1.558,-3.479 3.479,-3.479c1.922,0 3.479,1.558 3.479,3.479c0,1.921 -1.557,3.479 -3.479,3.479"
      />
    </g>
  </svg>
);
export const MenuArborescenceIcon = (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M19,21 L5,21 L5,21 C3.89543,21 3,20.1046 3,19 L3,10 L3,10 C3,8.89543 3.89543,8 5,8 L19,8 L19,8 C20.1046,8 21,8.89543 21,10 L21,19 L21,19 C21,20.1046 20.1046,21 19,21 C19,21 19,21 19,21 L19,21 Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16,21 L16,6 C16,4.89543 15.1046,4 14,4 L10,4 L10,4 C8.89543,4 8,4.89543 8,6 L8,6 L8,21"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MenuMetricsIcon = (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M3,8 L21,8 M12.5,17.25 L14.5,17.25 C14.6326,17.25 14.7598,17.3027 14.8536,17.3964 C14.9473,17.4902 15,17.6174 15,17.75 L15,21 L12.5,21 C12.3674,21 12.2402,20.9473 12.1464,20.8536 C12.0527,20.7598 12,20.6326 12,20.5 L12,17.75 C12,17.6174 12.0527,17.4902 12.1464,17.3964 C12.2402,17.3027 12.3674,17.25 12.5,17.25 Z M15.5,13 L17.5,13 C17.6326,13 17.7598,13.0527 17.8536,13.1464 C17.9473,13.2402 18,13.3674 18,13.5 L18,21 L15,21 L15,13.5 C15,13.3674 15.0527,13.2402 15.1464,13.1464 C15.2402,13.0527 15.3674,13 15.5,13 Z M18.5,15.25 L20.5,15.25 C20.6326,15.25 20.7598,15.3027 20.8536,15.3964 C20.9473,15.4902 21,15.6174 21,15.75 L21,20.5 C21,20.6326 20.9473,20.7598 20.8536,20.8536 C20.7598,20.9473 20.6326,21 20.5,21 L18,21 L18,15.75 C18,15.6174 18.0527,15.4902 18.1464,15.3964 C18.2402,15.3027 18.3674,15.25 18.5,15.25 Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9,18 L6,18 C5.20435,18 4.44129,17.6839 3.87868,17.1213 C3.31607,16.5587 3,15.7956 3,15 L3,7 C3,6.20435 3.31607,5.44129 3.87868,4.87868 C4.44129,4.31607 5.20435,4 6,4 L18,4 C18.7956,4 19.5587,4.31607 20.1213,4.87868 C20.6839,5.44129 21,6.20435 21,7 L21,11 M9,12 L7,12"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MenuEventsIcon = (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M3,9.5 L21,9.5 M7.5,3 L7.5,6 L7.5,3 Z M16.5,3 L16.5,6 L16.5,3 Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18,4.5 L6,4.5 C4.34315,4.5 3,5.84315 3,7.5 L3,18 C3,19.6569 4.34315,21 6,21 L18,21 C19.6569,21 21,19.6569 21,18 L21,7.5 C21,5.84315 19.6569,4.5 18,4.5 Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MenuTicketsIcon = (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M7,11 L17,11 M19,21 L5,21 C3.895,21 3,20.105 3,19 L3,5 C3,3.895 3.895,3 5,3 L19,3 C20.105,3 21,3.895 21,5 L21,19 C21,20.105 20.105,21 19,21 Z M7,7 L17,7 L7,7 Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3,15 L7.382,15 C7.761,15 8.107,15.214 8.276,15.553 L8.723,16.447 C8.893,16.786 9.239,17 9.618,17 L14.382,17 C14.761,17 15.107,16.786 15.276,16.447 L15.723,15.553 C15.893,15.214 16.239,15 16.618,15 L21,15"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MenuInstancesIcon = (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M7,3 L6,3 C4.895,3 4,3.895 4,5 L4,19 C4,20.105 4.895,21 6,21 L18,21 C19.105,21 20,20.105 20,19 L20,7.828 C20,7.298 19.789,6.789 19.414,6.414 L16.586,3.586 C16.211,3.211 15.702,3 15.172,3 L11,3"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20,8 L16,8 C15.448,8 15,7.552 15,7 L15,3"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10,2 L8,2 C7.448,2 7,2.448 7,3 L7,8 L9,7 L11,8 L11,3 C11,2.448 10.552,2 10,2 Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7,12 L16,12 M7,15.5 L16,15.5"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MenuDocumentsIcon = (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M18.414,6.414 L15.586,3.586 C15.211,3.211 14.702,3 14.172,3 L7,3 C5.895,3 5,3.895 5,5 L5,19 C5,20.105 5.895,21 7,21 L17,21 C18.105,21 19,20.105 19,19 L19,7.828 C19,7.298 18.789,6.789 18.414,6.414 L18.414,6.414 Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
    <path
      d="M19,8 L15,8 C14.448,8 14,7.552 14,7 L14,3 M8,11 L14,11 M8,14 L14,14 M8,17 L12.33,17"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
  </svg>
);

export const AddUserIcon = (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M15.0052,5.2447975 C16.6649,6.9045275 16.6649,9.5954775 15.0052,11.2551975 C13.3455,12.9148975 10.6545,12.9148975 8.9948,11.2551975 C7.33507,9.5954775 7.33507,6.9045275 8.9948,5.2447975 C10.6545,3.5850675 13.3455,3.5850675 15.0052,5.2447975"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4,19.9999975 C4,17.5149975 6.015,15.4999975 8.5,15.4999975 L11.083,15.4999975"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line
      x1="17.5"
      y1="20.4999975"
      x2="17.5"
      y2="15.4999975"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line
      x1="15"
      y1="17.9999975"
      x2="20"
      y2="17.9999975"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CloseIcon = (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <polygon
      fillRule="nonzero"
      points="19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12"
    />
  </svg>
);

export const ShareIcon = (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M19.2188975,15.4471975 C20.2603975,16.4886975 20.2603975,18.1772975 19.2188975,19.2188975 C18.1772975,20.2603975 16.4886975,20.2603975 15.4471975,19.2188975 C14.4055975,18.1772975 14.4055975,16.4886975 15.4471975,15.4471975 C16.4886975,14.4055975 18.1772975,14.4055975 19.2188975,15.4471975 Z M8.5528575,10.1141975 C9.5943875,11.1556975 9.5943875,12.8442975 8.5528575,13.8858975 C7.5113275,14.9273975 5.8226775,14.9273975 4.7811475,13.8858975 C3.7396175,12.8442975 3.7396175,11.1556975 4.7811475,10.1141975 C5.8226775,9.0726275 7.5113275,9.0726275 8.5528575,10.1141975 Z M19.2188975,4.7811475 C20.2603975,5.8226775 20.2603975,7.5113275 19.2188975,8.5528575 C18.1772975,9.5943875 16.4886975,9.5943875 15.4471975,8.5528575 C14.4055975,7.5113275 14.4055975,5.8226775 15.4471975,4.7811475 C16.4886975,3.7396175 18.1772975,3.7396175 19.2188975,4.7811475 Z M9.0400375,10.8100975 L14.9599975,7.8500975 M9.0400375,13.1898975 L14.9599975,16.1498975"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
  </svg>
);

export const CancelIcon = (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <polygon
      fillRule="nonzero"
      points="15.59 7 12 10.59 8.41 7 7 8.41 10.59 12 7 15.59 8.41 17 12 13.41 15.59 17 17 15.59 13.41 12 17 8.41"
    ></polygon>
  </svg>
);

export const SearchIcon = (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M11.059,18.118 C14.9576,18.118 18.118,14.9576 18.118,11.059 C18.118,7.16042 14.9576,4 11.059,4 C7.16042,4 4,7.16042 4,11.059 C4,14.9576 7.16042,18.118 11.059,18.118 Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
    <line
      x1="20"
      y1="20"
      x2="16.05"
      y2="16.05"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></line>
  </svg>
);

export const WebsiteIcon = (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M12,22 C10.6,22 9.29166667,21.7375 8.075,21.2125 C6.85833333,20.6875 5.8,19.975 4.9,19.075 C4,18.175 3.29166667,17.1125 2.775,15.8875 C2.25833333,14.6625 2,13.35 2,11.95 C2,10.55 2.25833333,9.24583333 2.775,8.0375 C3.29166667,6.82916667 4,5.775 4.9,4.875 C5.8,3.975 6.85833333,3.27083333 8.075,2.7625 C9.29166667,2.25416667 10.6,2 12,2 C13.4,2 14.7083333,2.25416667 15.925,2.7625 C17.1416667,3.27083333 18.2,3.975 19.1,4.875 C20,5.775 20.7083333,6.82916667 21.225,8.0375 C21.7416667,9.24583333 22,10.55 22,11.95 C22,13.35 21.7416667,14.6625 21.225,15.8875 C20.7083333,17.1125 20,18.175 19.1,19.075 C18.2,19.975 17.1416667,20.6875 15.925,21.2125 C14.7083333,21.7375 13.4,22 12,22 Z M15.95,8.25 L19.7,8.25 C19.15,7.1 18.3958333,6.14166667 17.4375,5.375 C16.4791667,4.60833333 15.375,4.06666667 14.125,3.75 C14.5416667,4.36666667 14.8958333,5.03333333 15.1875,5.75 C15.4791667,6.46666667 15.7333333,7.3 15.95,8.25 Z M9.6,8.25 L14.45,8.25 C14.2666667,7.36666667 13.9583333,6.5125 13.525,5.6875 C13.0916667,4.8625 12.5833333,4.13333333 12,3.5 C11.4666667,3.95 11.0166667,4.54166667 10.65,5.275 C10.2833333,6.00833333 9.93333333,7 9.6,8.25 Z M3.8,14.225 L7.775,14.225 C7.725,13.775 7.69583333,13.3708333 7.6875,13.0125 C7.67916667,12.6541667 7.675,12.3 7.675,11.95 C7.675,11.5333333 7.68333333,11.1625 7.7,10.8375 C7.71666667,10.5125 7.75,10.15 7.8,9.75 L3.8,9.75 C3.68333333,10.15 3.60416667,10.5083333 3.5625,10.825 C3.52083333,11.1416667 3.5,11.5166667 3.5,11.95 C3.5,12.3833333 3.52083333,12.7708333 3.5625,13.1125 C3.60416667,13.4541667 3.68333333,13.825 3.8,14.225 Z M9.875,20.25 C9.45833333,19.6166667 9.1,18.9333333 8.8,18.2 C8.5,17.4666667 8.25,16.6416667 8.05,15.725 L4.3,15.725 C4.93333333,16.9083333 5.66666667,17.8375 6.5,18.5125 C7.33333333,19.1875 8.45833333,19.7666667 9.875,20.25 Z M4.3,8.25 L8.075,8.25 C8.25833333,7.35 8.49166667,6.54583333 8.775,5.8375 C9.05833333,5.12916667 9.41666667,4.44166667 9.85,3.775 C8.6,4.09166667 7.50833333,4.625 6.575,5.375 C5.64166667,6.125 4.88333333,7.08333333 4.3,8.25 Z M12,20.55 C12.5833333,19.95 13.0708333,19.2625 13.4625,18.4875 C13.8541667,17.7125 14.175,16.7916667 14.425,15.725 L9.6,15.725 C9.83333333,16.725 10.1458333,17.625 10.5375,18.425 C10.9291667,19.225 11.4166667,19.9333333 12,20.55 Z M9.325,14.225 L14.7,14.225 C14.7666667,13.7083333 14.8083333,13.2875 14.825,12.9625 C14.8416667,12.6375 14.85,12.3 14.85,11.95 C14.85,11.6166667 14.8416667,11.2958333 14.825,10.9875 C14.8083333,10.6791667 14.7666667,10.2666667 14.7,9.75 L9.325,9.75 C9.25833333,10.2666667 9.21666667,10.6791667 9.2,10.9875 C9.18333333,11.2958333 9.175,11.6166667 9.175,11.95 C9.175,12.3 9.18333333,12.6375 9.2,12.9625 C9.21666667,13.2875 9.25833333,13.7083333 9.325,14.225 Z M14.15,20.225 C15.35,19.8416667 16.4291667,19.2666667 17.3875,18.5 C18.3458333,17.7333333 19.1166667,16.8083333 19.7,15.725 L15.975,15.725 C15.7583333,16.625 15.5041667,17.4416667 15.2125,18.175 C14.9208333,18.9083333 14.5666667,19.5916667 14.15,20.225 Z M16.2,14.225 L20.2,14.225 C20.3166667,13.825 20.3958333,13.4541667 20.4375,13.1125 C20.4791667,12.7708333 20.5,12.3833333 20.5,11.95 C20.5,11.5166667 20.4791667,11.1416667 20.4375,10.825 C20.3958333,10.5083333 20.3166667,10.15 20.2,9.75 L16.225,9.75 C16.275,10.3333333 16.3083333,10.7791667 16.325,11.0875 C16.3416667,11.3958333 16.35,11.6833333 16.35,11.95 C16.35,12.3166667 16.3375,12.6625 16.3125,12.9875 C16.2875,13.3125 16.25,13.725 16.2,14.225 Z"
      fillRule="nonzero"
    ></path>
  </svg>
);

export const PasswordIcon = (
  <svg
    width="54px"
    height="54px"
    viewBox="0 0 54 54"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
      <g id="Group" transform="translate(20.000000, 18.000000)" strokeWidth="1.5">
        <path d="M3,7 L3,4 C3,1.791 4.791,0 7,0 C9.209,0 11,1.791 11,4 L11,7" id="Path" />
        <line x1="7" y1="11" x2="7" y2="14" id="Path" />
        <path
          d="M12,18 L2,18 C0.895,18 0,17.105 0,16 L0,9 C0,7.895 0.895,7 2,7 L12,7 C13.105,7 14,7.895 14,9 L14,16 C14,17.105 13.105,18 12,18 Z"
          id="Path"
        />
      </g>
    </g>
  </svg>
);
